import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup as MUIRadioGroup } from '@mui/material';
import { translations } from '../../lib';

export type YesNoSelectorProps = {
    name: string;
    id?: string;
    idTrue?: string;
    idFalse?: string;
    onChange?: () => void;
};

const YesNoSelector = ({ name, id, idTrue, idFalse, onChange }: YesNoSelectorProps) => {
    const { values, errors, touched, setFieldValue } = useFormikContext<any>();

    const onSelectRadio = (e: { target: { value: any } }) => {
        if (onChange) {
            onChange();
        }
        setFieldValue(name, e.target.value);
    };

    const RadioGroup = (params: any) => {
        return (
            <MUIRadioGroup {...params} row sx={{ marginTop: '-15px' }}>
                <FormControlLabel value={'true'} control={<Radio />} label={translations.YES} id={idTrue} />
                <FormControlLabel value={'false'} control={<Radio />} label={translations.NO} id={idFalse} />
            </MUIRadioGroup>
        );
    };

    return (
        <>
            <FormControl required={true}>
                <Field
                    type="boolean"
                    name={name}
                    id={id}
                    as={RadioGroup}
                    size="big"
                    value={values[name]}
                    onChange={onSelectRadio}
                />

                {touched[name] && errors[name] ? (
                    <FormHelperText error={true}>
                        <>{errors[name]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export default YesNoSelector;
